import type { IronSession, SessionOptions } from 'iron-session'
import type { CustomerDTO } from 'ecosystem'

// Re-export so downstream consumers can depend on the type without a direct
// `iron-session` dependency.
export type { SessionOptions, IronSession }

export const sessionOptionsFactory = (cookieName: string, password: string): SessionOptions => {
  return {
    password,
    cookieName,
    // secure: true should be used in production (HTTPS) but can't be used in development (HTTP)
    cookieOptions: {
      secure: process.env.NODE_ENV === 'production',
      httpOnly: true,
      sameSite: 'lax'
    }
  }
}

// Shape returned by /api/auth/user (and what useUser exposes to client components).
// `customer` is fetched fresh per request in createUserHandler — it is NOT persisted to
// the session cookie. Use `!!user?.customer` to check "logged in";
// `user?.customer?.id` gives the customer id when needed.
export interface User {
  customer: CustomerDTO | null
}

// Persisted iron-session payload. Only the customerId is stored; the full
// customer is re-fetched from the BE on each /api/auth/user call.
export interface SessionData {
  customerId?: string
}

export type AppSession = IronSession<SessionData>
